/*
export interface ILocationItem {
  name: string;
  county_id: number;
  county_name: string;
  country: string;
  state_abbrev: string;
  state_name: string;
  zip: string;
  studio_id: number;
  result_type: string; // e.g. "country", "state", "city", "postcode", "street", "amenity", "suburb"
}
  */

export enum ESearchLocationFormVariants {
  MODAL = 'modal',
  HERO = 'hero',
}

/*
export interface IFormattedLocationItem extends ILocationItem {
  displayText: string;
}
  */
